<template>
  <div class="">
    <div class="col-12">
      <b-card header="<i class='fa fa-file-o'></i> Detil Pengajuan">
        <div v-if=" !DataHeader || !listdokap " style="height: 20rem"
          class="d-flex align-items-center justify-content-center">
          <half-circle-spinner :animation-duration=" 1000 " :size=" 60 " :color=" '#000000' " />
        </div>
        <transition name="fade" mode="out-in">
          <div class="" v-if=" DataHeader && listdokap ">
            <div class="row">
              <div class="col-12">
                <div v-if=" DataHeader.status === '10' " class="p-3 pull-right">
                  <button type="button" class="btn btn-success" @click=" cekkirim "><i class="fa fa-send"></i>
                    Kirim</button>
                </div>
                <!-- <div  class="p-3 pull-right">
                  <button  type="button" class="btn btn-success" @click="cekkirim"><i class="fa fa-send"></i> Kirim</button>
                </div> -->
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <b-card header="<i class='fa fa-file-o'></i> Data Pengajuan Izin">
                  <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <table class="table table-bordered table-sm">
                        <tr>
                          <td class="d-none d-sm-block">{{ DataHeader.URAIAN}}</td>
                          <td>{{ DataHeader.npwp}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">Nama</td>
                          <td>{{ DataHeader.NM_PERUSAHAAN}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">Alamat</td>
                          <td>{{ DataHeader.AL_PERUSAHAAN}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">No HP/Telepon</td>
                          <td>{{ DataHeader.no_hp}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">Email</td>
                          <td>{{ DataHeader.email}}</td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                      <table class="table table-bordered table-sm">
                        <tr>
                          <td class="d-none d-sm-block">Kantor</td>
                          <td>020400 - KPU BC Tipe B Batam</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">No Permohonan</td>
                          <td>{{ DataHeader.no_mohon}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">Tanggal Permohonan</td>
                          <td>{{ DataHeader.tgl_mohon}}</td>
                        </tr>
                        <tr>
                          <td class="d-none d-sm-block">Jenis Permohonan Izin</td>
                          <td>{{ DataHeader.nama_ijin}}</td>
                        </tr>
                      </table>
                    </div>

                  </div>
                </b-card>
              </div>
              <div class="col-12">
                <b-card header="<i class='fa fa-file-o'></i> Dokumen Pelengkap">
                  <div class="row">
                    <div class="col-12">
                      Lampiran Dokumen / Data
                      <button title="Tambah Dokumen/Data Pelengkap" type="button" class="btn btn-success pull-right"
                        @click=" addModal "><i class="fa fa-plus"></i> Add Dokap</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <table class="table table-bordered table-responsive table-sm">
                        <thead>
                          <tr>
                            <th>Nama Dokumen</th>
                            <th class="d-none d-sm-block">Nomor</th>
                            <th>Tanggal</th>
                            <th class="d-none d-md-block">Keterangan</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="dokap in listdokap">
                            <td>{{ dokap.nama_dokap}}</td>
                            <td class="d-none d-sm-block">{{ dokap.isian1}}</td>
                            <!-- <td>{{ dokap.isian1 + referensiDokapDtl(dokap.tabel_ref, dokap.kolom1, dokap.kolom2, dokap.isian1) }}</td> -->
                            <td>{{ dokap.isian2}}</td>
                            <td class="d-none d-md-block">{{ dokap.keterangan}}</td>
                            <td>
                              <a title="Download Dokumen Pelengkap" v-if=" dokap.url_file !== null "
                                :href=" dokap.url_file " target="_blank" class="btn btn-warning"><i
                                  class="fa fa-download"></i></a>
                              <!-- <a title="Download Dokumen Pelengkap" v-if="dokap.nm_file !== null" :href="'http://103.233.145.212/backper/public' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                              <!-- <a title="Download Dokumen Pelengkap" v-if="dokap.nm_file !== null" :href="'http://localhost/backper/public' + dokap.url_file + '/' + dokap.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                              <button title="Edit Dokumen/Data Pelengkap" type="button"
                                @click=" editDokap( dokap.id_permohonan_dokap ) " class="btn btn-primary"><i
                                  class="fa fa-edit"></i></button>
                              <!-- tombol edit dokap detail -->
                              <button title="Edit Dokumen/Data Pelengkap" v-if=" dokap.kd_dokap === 151 || dokap.kd_dokap === 256" type="button"
                                @click=" opendtl( dokap.id_permohonan_dokap,dokap.kd_dokap ) "
                                class="btn btn-secondary"><i class="fa fa-edit"></i></button>
                              <button title="Edit Dokumen/Data Pelengkap"
                                v-if=" dokap.kd_dokap === 145 || dokap.kd_dokap === 146 " type="button"
                                @click=" opendtl( dokap.id_permohonan_dokap,dokap.kd_dokap ) "
                                class="btn btn-secondary"><i class="fa fa-edit"></i></button>
                              <!--  -->
                              <button title="Hapus Dokumen/Data Pelengkap" v-if=" dokap.fl_mandatory === null "
                                class="btn btn-danger" @click=" confir( dokap.id_permohonan_dokap ) "><i
                                  class="fa fa-trash-o"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card>
              </div>
              <div class="col-12">
                <router-link :to=" '/pengajuan' " class="btn btn-secondary pull-right"><i class="fa fa-mail-reply"></i>
                  Back</router-link>
              </div>
            </div>
          </div>
        </transition>
      </b-card>
    </div>
    <b-modal hide-footer title="Tambah Dokumen Pelengkap" v-model=" ModalDokap " @ok=" ModalDokap = false ">
      <div class="row">
        <div class="col-12">
          <vue-progress-bar></vue-progress-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <b-form-fieldset label="Jenis Dokumen Pelengkap">
            <model-list-select class="form-control" :list="jndokap" option-value="kd_dokap" option-text="nama_dokap" v-model="isidokap.jndok" @input="getDtlDokap( isidokap.jndok )"></model-list-select>
            <!-- <select title="Pilih Jenis Dokumen/Data Pelengkap" class="form-control" v-model=" isidokap.jndok ">
              <option value="">Pilih Jenis Dokumen/Data</option>
              <option v-for="jn in jndokap" @click=" getDtlDokap( jn.kd_dokap ) " :value=" jn.kd_dokap ">{{
                  jn.nama_dokap
              }}
              </option>
            </select> -->
          </b-form-fieldset>
          <b-form-fieldset :label=" field.isi1 ">
            <!-- <input v-if="field.tipe1 === 'date'" name="This" v-validate="'required|email'" type="date" v-model="isidokap.isian1" class="form-control">
            <input v-if="field.tipe1 === 'text'" name="This" v-validate="'required|email'" type="text" v-model="isidokap.isian1" class="form-control"> -->
            <select title="Pilih Negara" class="form-control" v-model=" isidokap.negara "
              v-if=" field.tabel_ref === 'referensi.tr_pelln' || field.tabel_ref === 'referensi.tr_pelabuhan' ">
              <option value="">Pilih Negara</option>
              <option v-for="jn in jnNegara" @click=" referensiDokap() " :value=" jn.id_lokasi ">{{ jn.nm_lokasi}}
              </option>
            </select>
            <select title="Pilih Data Pelengkap" lass="form-control" v-model=" isidokap.isian1 "
              v-if=" field.tabel_ref !== null ">
              <option value="">Pilih Jenis Data</option>
              <option v-for="jn in jnPelln" :value=" jn.id_lokasi ">{{ jn.nm_lokasi}}</option>
            </select>
            <input title="Nomor/Kode Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'date' && field.tabel_ref === null " type="date" v-model=" isidokap.isian1 "
              class="form-control">
            <input title="Nomor/Kode Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'text' && field.tabel_ref === null " type="text" v-model=" isidokap.isian1 "
              class="form-control">
            <vue-numeric title="Nomor/Kode Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'number' && field.tabel_ref === null " separator="." v-bind:precision=" 2 "
              v-model=" isidokap.isian1 "></vue-numeric>
            <small class="text-danger" v-show=" errors.has( 'This' ) ">
              {{ errors.first( 'This' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.tipe2 === 'text' " :label=" field.isi1 ">
            <input title="Tanggal Dokumen/Data" name="Isi" v-validate=" 'required|field' " type="text"
              v-model=" isidokap.isian2 " class="form-control">
            <small class="text-danger" v-show=" errors.has( 'Isi' ) ">
              {{ errors.first( 'Isi' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.tipe2 === 'Date' " label="Tanggal">
            <input name="Tanggal" v-validate=" 'required|field' " type="date" v-model=" isidokap.isian2 "
              class="form-control">
            <small class="text-danger" v-show=" errors.has( 'Tanggal' ) ">
              {{ errors.first( 'Tanggal' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.expire === 'Y' " label="Akhir Berlaku">
            <b-form-input title="Akhir Berlaku Dokumen/Data" name="Akhir Berlaku" v-validate=" 'required|field' "
              type="date" v-model=" edit.akhirberlaku "></b-form-input>
            <small class="text-danger" v-show=" errors.has( 'Akhir Berlaku' ) ">
              {{ errors.first( 'Akhir Berlaku' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset label="Keterangan">
            <input title="Keterangan Terkait Dokumen/Data" class="form-control" type="text"
              v-model=" isidokap.keterangan "></input>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.fl_file === 'Y' " label="Upload File (Max. 800 Kb)">
            <input type="file" class="form-control" @change=" fileChanged ">
          </b-form-fieldset>
          <button type="button" class="btn btn-success pull-right" @click=" saveDokap() " name="button">Save</button>
        </div>
      </div>
    </b-modal>

    <!-- Modal EDIT -->
    <b-modal hide-footer title="Edit Dokumen Pelengkap" v-model=" Modaledit " @ok=" Modaledit = false ">
      <div class="row">
        <div class="col-12">
          <vue-progress-bar></vue-progress-bar>
        </div>
      </div>
      <div class="row">
        <loading :active.sync=" isLoadingEdit " :is-full-page=" false "></loading>
        <div class="col-12">
          <b-form-fieldset label="Edit Dokumen Pelengkap">
            <select title="Jenis Dokumen/Data" class="form-control" v-model=" edit.jndok " disabled>
              <option value="">Pilih Jenis Dokumen</option>
              <option v-for="jn in jndokap" @click=" getDtlDokap( jn.kd_dokap ) " :value=" jn.kd_dokap ">{{
                  jn.nama_dokap
              }}
              </option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset :label=" field.isi1 ">
            <!-- <vue-instant class="form-control" v-on:input="referensiDokap()" v-model="edit.negara" :suggestion-attribute="suggestionAttribute" :suggestions="jnPelln"></vue-instant> -->
            <!-- <input name="This" v-validate="'required'" v-on:input="referensiDokap()" v-model="edit.negara" class="form-control"> -->
            <model-list-select class="form-control" :list=" jnNegara " @input=" referensiDokap() "
              v-if=" field.tabel_ref === 'referensi.tr_pelln' || field.tabel_ref === 'referensi.tr_pelabuhan' "
              v-model=" edit.negara " option-value="id_lokasi" option-text="nm_lokasi" name="Nama Negara"
              placeholder="-- Pilih Negara --">
            </model-list-select>
            <!-- <select title="Pilih Kode Negara" class="form-control"  @change="referensiDokap()" v-model="edit.negara" v-if="field.tabel_ref === 'referensi.tr_pelln' || field.tabel_ref === 'referensi.tr_pelabuhan'">
              <option value="">Pilih Negara</option>
              <option  v-for="jn in jnNegara" :value="jn.id_lokasi" :key="jn.id_lokasi">{{ jn.nm_lokasi }}</option>
            </select> -->
            <!-- <select title="Nomor/Kode Dokumen/Data" class="form-control" v-model="edit.isian1" v-if="field.tabel_ref !== null">
              <option value="">Pilih Jenis Dokumen</option>
              <option @click="edit.keterangan = jn.nm_lokasi" v-for="jn in jnPelln" :value="jn.id_lokasi">{{ jn.nm_lokasi }}</option>
            </select> -->
            <model-list-select class="form-control" :list=" jnPelln " v-if=" field.tabel_ref !== null "
              v-model=" edit.isian1 " option-value="id_lokasi" option-text="nm_lokasi" name="Nama Pelabuhan"
              placeholder="-- Pilihan --">
            </model-list-select>
            <input title="Tanggal Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'date' && field.tabel_ref === null " type="date" v-model=" edit.isian1 "
              class="form-control">
            <input :maxlength=" field.maxlength " title="Nomor/Kode Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'text' && field.tabel_ref === null " type="text" v-model=" edit.isian1 "
              class="form-control">
            <!-- <input title="Nomor/Kode Dokumen/Data" name="This" v-validate="'required'" v-if="field.tipe1 === 'number'&&field.tabel_ref === null" type="number" v-model="edit.isian1" class="form-control"> -->
            <vue-numeric class="form-control" title="Nomor/Kode Dokumen/Data" name="This" v-validate=" 'required' "
              v-if=" field.tipe1 === 'number' && field.tabel_ref === null " separator="." v-bind:precision=" 2 "
              v-model=" edit.isian1 "></vue-numeric>
            <small class="text-danger" v-show=" errors.has( 'This' ) ">
              {{ errors.first( 'This' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.tipe2 === 'text' " :label=" field.isi2 ">
            <input :maxlength=" field.maxlength2 " title="Nomor/Kode Dokumen/Data" name="Isi" v-validate=" 'required' "
              type="text" v-model=" edit.isian2 " class="form-control">
            <small class="text-danger" v-show=" errors.has( 'Isi' ) ">
              {{ errors.first( 'Isi' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.tipe2 === 'Date' " label="Tanggal">
            <input title="Tanggal Dokumen/Data" name="Tanggal" v-validate=" 'required' " type="date"
              v-model=" edit.isian2 " class="form-control">
            <small class="text-danger" v-show=" errors.has( 'Tanggal' ) ">
              {{ errors.first( 'Tanggal' )}}
            </small>
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.expire === 'Y' " label="Akhir Berlaku">
            <b-form-input title="Akhir Berlaku Dokumen/Data" name="Akhir Berlaku" v-validate=" 'required' " type="date"
              v-model=" edit.akhirberlaku "></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset label="Keterangan">
            <input title="Keterangan Dokumen/Data" class="form-control" type="text" v-model=" edit.keterangan ">
          </b-form-fieldset>
          <b-form-fieldset v-if=" field.fl_file === 'Y' " title="Upload Dokumen" label="Upload File (Max. 2000 Kb)">
            <input title="Upload Dokumen" type="file" class="form-control" @change=" fileChanged ">
          </b-form-fieldset>
          <button type="button" class="btn btn-success pull-right" @click=" updateDokap() " name="button">Save</button>
        </div>
      </div>
    </b-modal>

    <!-- PETI KEMAS  -->
    <b-modal hide-footer title="Edit Dokumen Pelengkap" no-close-on-backdrop v-model=" Modaleditdtl "
      @ok=" Modaleditdtl = false " size="medium">
      <loading :active.sync=" isLoadingEdit " :is-full-page=" false "></loading>
      <form @submit.prevent=" addRow ">
        <div class="form-group row">
          <div class="col-6">
            <b-form-fieldset label="Nomor Peti Kemas">
              <input maxlength="11" title="Nomor Peti Kemas" name="petikemas" required v-model=" nocont "
                class="form-control">
              <small class="text-danger" v-show=" errors.has( 'petikemas' ) ">
                {{ errors.first( 'petikemas' )}}
              </small>
            </b-form-fieldset>
          </div>
          <div class="col-3">
            <b-form-fieldset label="Ukuran">
              <input maxlength="2" title="Nomor Peti Kemas" name="ukuran" required v-model=" ukcont "
                class="form-control">
              <small class="text-danger" v-show=" errors.has( 'ukuran' ) ">
                Wajib diisi dan berisi angka
              </small>
            </b-form-fieldset>
          </div>
          <div class="col-2">
            <b-form-fieldset label="<br>">
              <button title="Tambah" type="submit" class="btn btn-primary"><i class="fa fa-plus"></i>
                Tambah</button>
            </b-form-fieldset>
          </div>
        </div>
      </form>
      <div class="form-group row">
        <div class="col-6">
          <b-form-fieldset>
            <input type="file" ref="fileupload" @change=" loadCSV ">
            <small>upload file csv (format csv menggunakan koma (,) bukan titik koma (;))</small>
          </b-form-fieldset>
        </div>
        <div class="col-6">
          <a :href=" $http.options.root + '/dllaporan/formatcont' "><button class="btn btn-warning">Download Format
              CSV</button></a>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <!-- BUAT BIKIN SCROLL -->
          <div style="height:300px;max-height:300px;overflow-y:scroll;">
            <table class="table table-responsive-sm table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nomor Peti Kemas</th>
                  <th>Ukuran</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(peti,index) in cont" :key=" peti.isian1 ">
                  <td>{{ index + 1}}</td>
                  <td>{{ peti.isian1}}</td>
                  <td>{{ peti.isian2}}</td>
                  <td>
                    <button title="Hapus" type="button" @click=" hapusrow( index ) " class="btn btn-danger"><i
                        class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="">
        <button type="button" class="btn btn-danger pull-right" @click=" Modaleditdtl = false "
          name="button">Batal</button> &nbsp;
        <button type="button" class="btn btn-success pull-right" @click=" savedokapdtl " name="button">Simpan</button>
      </div>
    </b-modal>

    <!-- Detail Dokumen Upload -->
    <b-modal hide-footer title="Edit Dokumen Pelengkap" v-model=" Modaleditdtl1 " @ok=" Modaleditdtl1 = false "
      size="lg">
      <div class="form-group row">
        <div class="col-3">
          <b-form-fieldset label="Nomor">
            <input title="Nomor" name="" v-validate=" 'required' " v-model=" nocont " class="form-control">
            <!-- <small class="text-danger" v-show="errors.has('petikemas')">
              Nomor Peti Kemas wajib diisi
            </small> -->
          </b-form-fieldset>
        </div>
        <div class="col-2">
          <b-form-fieldset label="Tanggal">
            <input type="date" title="Nomor Peti Kemas" name="" v-validate=" 'required' " v-model=" ukcont "
              class="form-control">
            <!-- <small class="text-danger" v-show="errors.has('ukuran')">
              Wajib diisi dan berisi angka
            </small> -->
          </b-form-fieldset>
        </div>
        <div class="col-6">
          <b-form-fieldset label="Upload File (Max. 800 Kb)">
            <input type="file" class="form-control" @change=" fileChanged ">
            <div class="row">
              <div class="col-12">
                <vue-progress-bar></vue-progress-bar>
              </div>
            </div>
          </b-form-fieldset>
        </div>
        <div class="col-2">
          <b-form-fieldset label="">
            <button title="Tambah Dokumen" type="button" @click=" savedokapdtl1 " class="btn btn-primary"><i
                class="fa fa-plus"></i> Tambah Dokumen</button>
          </b-form-fieldset>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-12">
          <!-- BUAT BIKIN SCROLL -->
          <div style="height:300px;max-height:300px;overflow-y:scroll;">
            <table class="table table-responsive-sm table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Nomor</th>
                  <th>Tanggal</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(peti,index) in cont" :key=" peti.isian1 ">
                  <td>{{ index + 1}}</td>
                  <td>{{ peti.isian1}}</td>
                  <td>{{ peti.isian2}}</td>
                  <td>
                    <a title="Download Dokumen Pelengkap" v-if=" peti.nm_file !== null "
                      :href=" $http.options.base + peti.url_file + '/' + peti.nm_file " target="_blank"
                      class="btn btn-warning"><i class="fa fa-download"></i></a>
                    <!-- <a title="Download Dokumen Pelengkap" v-if="peti.nm_file !== null" :href="'http://localhost/backper/public' + peti.url_file + '/' + peti.nm_file" target="_blank" class="btn btn-warning"><i class="fa fa-download"></i></a> -->
                    <button title="Hapus" type="button" @click=" confirmdtl( peti.id_permohonan_dokap_dtl ) "
                      class="btn btn-danger"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- DATA / DOKUMEN PPFTZ ATAS PENGELUARAN BARANG PETI KEMAS PART OFTANPA DILAKUKAN STRIPPING -->
     <b-modal hide-footer title="Edit Dokumen Pelengkap" no-close-on-backdrop v-model="Modaleditdtl2" @ok="Modaleditdtl2 = false" size="lg">
      <loading :active.sync=" isLoadingEdit " :is-full-page=" false "></loading>
      <div class="form-group row">
        <div class="col-3">
          <b-form-fieldset label="Nomor PPFTZ*">
            <input title="No. PPFTZ" type="text" class="form-control" placeholder="No. PPFTZ" v-model="dataNoStrip.noPpftz">
          </b-form-fieldset>
        </div>
        <div class="col-3">
          <b-form-fieldset label="Tanggal PPFTZ*">
            <input title="Tgl. PPFTZ" type="date" class="form-control" placeholder="Tgl. PPFTZ" v-model="dataNoStrip.tglPpftz">
          </b-form-fieldset>
        </div>
        <div class="col-3">
          <b-form-fieldset label="Nomor BC 1.1*">
            <input title="No. BC 1.1" type="text" class="form-control" placeholder="No. BC 1.1" v-model="dataNoStrip.noBc11">
          </b-form-fieldset>
        </div>
        <div class="col-3">
          <b-form-fieldset label="Tanggal BC 1.1*">
            <input title="Tgl. BC 1.1" type="date" class="form-control" placeholder="Tgl. BC 1.1" v-model="dataNoStrip.tglBc11">
          </b-form-fieldset>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-3">
            <input title="Pos" type="text" class="form-control" placeholder="Pos*" v-model="dataNoStrip.pos">
        </div>
        <div class="col-3">
            <input title="No. Kontainer" type="text" class="form-control" placeholder="No. Kontainer*" v-model="dataNoStrip.noKontainer">
        </div>
        <div class="col-3">
            <input title="Uk. Kontainer" type="text" class="form-control" placeholder="Uk. Kontainer*" v-model="dataNoStrip.ukKontainer">
        </div>
        <div class="col-3">
            <button class="btn btn-primary" @click="savedokapdtl2"><i class="fa fa-plus"></i> Tambah</button>
        </div>
      </div>
      <table class="table table-bordered table-sm">
        <thead>
          <tr>
            <th>No</th>
            <th>No. / Tgl. PPFTZ</th>
            <th>No. / Tgl. BC 1.1</th>
            <th>Pos</th>
            <th>No. / Uk. Kontainer</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in cont" :key="item.isian1">
            <td>{{ index + 1 }}</td>
            <td>{{ item.isian1 + ' / ' + item.isian2 }}</td>
            <td>{{ item.isian3 + ' / ' + item.isian4 }}</td>
            <td>{{ item.isian5 }}</td>
            <td>{{ item.isian6 + ' / ' + item.isian7 + '"LCL' }} <button class="btn btn-danger pull-right"><i class="fa fa-trash" @click="confirmdtl2(item.id_permohonan_dokap_dtl)"></i></button></td>
          </tr>
        </tbody>
      </table>
     </b-modal>


    <b-modal hide-footer title="Persetujuan" v-model=" ModalDisclaimer " @ok=" ModalDisclaimer = false ">
      <div class="row">
        <loading :active.sync=" isLoadingKirim " :is-full-page=" false "></loading>
        <div class="col-12">
          <b-form-fieldset>
            <b-form-checkbox v-model=" disclaimer " value="Y" unchecked-value="">
              Saya menyatakan bahwa data yang disampaikan adalah benar
              dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan
            </b-form-checkbox>
            <div v-if=" disclaimer === 'Y' " class="p-3 pull-right">
              <button type="button" class="btn btn-success" @click=" kirim "><i class="fa fa-send"></i> Kirim</button>
            </div>
          </b-form-fieldset>
        </div>
      </div>
    </b-modal>

    <b-modal v-model=" ModalError " title="Hasil Validasi" class="modal-danger" ok-variant="danger">
      <ul>
        <li v-for="val in validasi" class="font">{{ val}}</li>
      </ul>
    </b-modal>
  </div>
</template>
<script>
import swal from 'sweetalert'
import VueNumeric from 'vue-numeric'
import Loading from 'vue-loading-overlay'
import ContainerValidator from 'container-validator'
import {HalfCircleSpinner} from 'epic-spinners'
import {Validator} from 'vee-validate'
import {ModelListSelect} from 'vue-search-select'

Validator.extend('container', {
  getMessage: field => field + ' tidak valid.',
  validate: value => {
    const validasi = new ContainerValidator()
    return validasi.isValid(value)
  }
})

export default {
  data () {
    return {
      Modaledit: false,
      Modaleditdtl: false,
      Modaleditdtl1: false,
      Modaleditdtl2: false,
      ModalDokap: false,
      ModalDisclaimer: false,
      ModalError: false,
      disclaimer: '',
      validasi: [],
      nmTabel: '',
      nmKolom: '',
      nmPar: '',
      uraian: '',
      nocont: '',
      ukcont: '',
      jmlcont: 0,
      jmlck: 0,
      jmlba: 0,
      cont: [],
      isian: '',
      isLoadingEdit: false,
      isLoadingKirim: false,
      fileSize: 0,
      fileExt: '',
      fileName: '',
      fileValid: '',
      DataHeader: null,
      dokap_current: '',
      kd_dokap_current: '',
      listdokap: null,
      dokapdtl: [],
      jndokap: [],
      jnPelln: [],
      jnNegara: [],
      user: [],
      suggestionAttribute: 'original_title',
      isidokap: {
        jndok: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        negara: '-'
      },
      idijin: '',
      field: {
        isi1: '',
        tipe1: '',
        isi2: '',
        tipe2: '',
        expire: '',
        kolom1: '',
        kolom2: '',
        tabel_ref: '',
        fl_file: '',
        maxlength: '',
        maxlength2: ''
      },
      edit: {
        idperdokap: '',
        idpermohonan: '',
        isian1: '',
        isian2: '',
        akhirberlaku: '',
        keterangan: '',
        file: '',
        pelln: '',
        negara: '-',
        fileSize: '',
        fl_file: ''
      },
      pdf: {
        show: true,
        pdfList: [
          '',
          'http://localhost/backper/public/file/dokap/20171212/9oAFswM38T3ZnNW9.pdf'
        ],
        src: '',
        loadedRatio: 0,
        page: 1,
        numPages: 0,
        rotate: 0
      },
      parse_header: [],
      parse_csv: [],
      sortOrders: {},
      sortKey: '',
      dataNoStrip: {
        noPpftz: '',
        tglPpftz: '',
        noBc11: '',
        tglBc11: '',
        pos: '',
        noKontainer: '',
        ukKontainer: ''
      }
    }
  },
  created () {
    this.getHeader()
    this.getDokap()
    this.getJnDokap()
    this.getNegara()
    this.edit.negara = '-'
  },
  methods: {
    addRow () {
      if (this.cont.length >= this.jmlcont) {
        swal('error', 'isian tidak boleh lebih dari ' + this.jmlcont, 'error')
      } else {
        // this.$validator.validateAll().then((result) => {
        //   if (result) {
        this.cont.push({
          isian1: this.nocont,
          isian2: this.ukcont
        })
        this.cont = this.cont
      }
      //   })
      // }
    },
    hapusrow (index) {
      this.cont.splice(index, 1)
      this.cont = this.cont
    },
    cekkirim () {
      this.ModalDisclaimer = true
    },
    kirim () {
      if (this.disclaimer === 'Y') {
        swal({
          title: 'Kirim data',
          text: 'Anda yakin akan mengirim data ini?',
          icon: 'warning',
          buttons: {
            cancel: 'Cancel',
            Yes: 'Yes'
          }
        })
          .then((value) => {
            switch (value) {
              case 'Yes':
                this.isLoadingKirim = true
                var data = {
                  user: this.$store.getters['auth/user']['username'],
                  idmohon: this.$route.params.idmohon
                }
                this.$http.post('kirim', data)
                  .then(response => {
                    if (response.data.hasil) {
                      var mail = {
                        page: 'kirim',
                        idmohon: this.$route.params.idmohon
                      }
                      this.$http.post('bc/mail/sendmail', mail)
                      var mail1 = {
                        page: 'petugas',
                        idmohon: this.$route.params.idmohon
                      }
                      this.$http.post('bc/mail/sendmail', mail1)
                    }
                    swal(response.data.status, response.data.message, response.data.status).then(() => {
                      this.$router.push('/pengajuan')
                    })
                    this.isLoadingKirim = false
                  }).catch((error) => {
                    console.log(error)
                    if (error.status === 422) {
                      this.ModalDisclaimer = false
                      this.validasi = error.body
                      this.ModalError = true
                    } else {
                      swal('error', JSON.parse(error.bodyText).message, 'error')
                    }
                    this.isLoadingKirim = false
                  })
            }
          })
      } else {
        swal('Kirim Data', 'Pengiriman data tidak berhasil, disclaimer belum diisi...!!!', 'error')
      }
    },
    savedokapdtl () {
      this.isLoadingEdit = true
      if (this.jmlcont <= this.cont.length) {
        var data = {
          idrekam: this.$store.getters['auth/user']['username'],
          id_permohonan_dokap: this.dokap_current,
          cont: this.cont
        }
        this.$http.post('savedokapdtl', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.Modaleditdtl = false
            this.isLoadingEdit = false
          })
      } else {
        swal('error', 'isian tidak sama dengan jumlah', 'error')
        this.isLoadingEdit = false
      }
    },
    savedokapdtl1 () {
      if (this.cekFile()) {
        var data = {
          id_dokap: this.dokap_current,
          kd_dokap: this.kd_dokap_current,
          isian1: this.nocont,
          isian2: this.ukcont,
          file: this.isidokap.file,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('savedokapdtl1', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.ResetField()
            this.Reset()
            this.getDokapdtl()
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
      }
    },
    fileChanged (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.isidokap.file = e.target.result
        this.edit.file = e.target.result
        this.$Progress.finish()
      }
    },
    fileChangeddtl (e) {
      this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.fileSize = e.target.files[0].size / 1024
      this.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.isidokap.file = e.target.result
        this.edit.file = e.target.result
        this.$Progress.finish()
      }
    },
    cekFile () {
      var hasil = true
      if (this.fileSize > 0) {
        this.fileValid = 'File ' + this.fileName
        if (this.fileSize > 2100) {
          this.fileValid = this.fileValid + ' berukuran ' + Math.round(this.fileSize * 100) / 100 + ' Kb, max. 2000 Kb. ' + '\n\r'
          hasil = false
        }
        // if (this.fileExt !== 'application/pdf') {
        //   this.fileValid = this.fileValid + 'File bukan pdf, ' + this.fileExt
        //   hasil = false
        // }
      }
      return hasil
    },
    getDtlDokap (iddokap) {
      this.$http.get('ref/jndokap/' + iddokap)
        .then(response => {
          this.field.isi1 = response.data.isian1
          this.field.tipe1 = response.data.tipe1
          this.field.maxlength = response.data.maxlength
          this.field.isi2 = response.data.isian2
          this.field.maxlength2 = response.data.maxlength2
          this.field.tipe2 = response.data.tipe2
          this.field.expire = response.data.expire
          this.field.tabel_ref = response.data.tabel_ref
          this.field.kolom1 = response.data.kolom1
          this.field.kolom2 = response.data.kolom2
          this.field.fl_file = response.data.fl_file
          if (this.field.tabel_ref === 'referensi.tr_pelln' || this.field.tabel_ref === 'referensi.tr_pelabuhan') {
            // this.referensiDokap()
          } else {
            this.referensiDokap()
          }
        })
    },
    getJnDokap () {
      this.$http.get('ref/jndokap')
        .then(response => {
          this.jndokap = response.data
        })
    },
    getHeader () {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        idmohon: this.$route.params.idmohon
      }
      this.user = data
      this.$http.post('dtlheader', data)
        .then(response => {
          this.DataHeader = response.data
          this.idijin = response.data.id_ijin
        })
    },
    getDokap () {
      this.isLoadingEdit = true
      var idijinn = {
        user: this.$store.getters['auth/user']['username'],
        idijin: this.$route.params.idmohon
      }
      this.$http.post('dokap', idijinn)
        .then(response => {
          this.listdokap = response.data
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].kd_dokap === 151) {
              this.jmlcont = response.data[i].isian1
            } else if (response.data[i].kd_dokap === 145) {
              this.jmlck = response.data[i].isian1
            } else if (response.data[i].kd_dokap === 146) {
              this.jmlba = response.data[i].isian1
            }
          }
          this.isLoadingEdit = false
        })
    },
    getDokapdtl () {
      this.isLoadingEdit = true
      var iddokap = {
        iddokap: this.dokap_current
      }
      this.$http.post('dokapdtl', iddokap)
        .then(response => {
          this.cont = response.data
          this.isLoadingEdit = false
        })
    },
    referensiDokap () {
      // this.isLoadingEdit = true
      var neg = ''
      if (this.ModalDokap === true) {
        neg = this.isidokap.negara
      } else {
        neg = this.edit.negara
      }
      if (this.field.tabel_ref != null) {
        this.isLoadingEdit = true
        this.$http.get('ref/referensiDokap/' + this.field.tabel_ref + '/' + this.field.kolom1 + '/' + this.field.kolom2 + '/' + neg)
          .then(response => {
            this.jnPelln = response.data
            this.isLoadingEdit = false
          })
      }
    },
    referensiDokapDtl (tabel, kolom1, kolom2, par) {
      if (tabel !== null) {
        this.$http.get('ref/referensiDokapDtl/' + tabel + '/' + kolom1 + '/' + kolom2 + '/' + par)
          .then(response => {
            this.uraian = response.data.nm_lokasi
          })
      } else {
        this.uraian = ''
      }
      return this.uraian
    },
    getNegara () {
      this.$http.get('ref/referensiDokap/referensi.tr_negara/id_negara/nm_negara/-')
        .then(response => {
          this.jnNegara = response.data
        })
    },
    addModal () {
      this.ModalDokap = true
      this.Reset()
    },
    opendtl (id, kd) {
      if (kd === 151) {
        this.Modaleditdtl = true
        this.dokap_current = id
        this.getDokapdtl()
        this.$refs.fileupload.value = null
      } else if (kd === 145 || kd === 146) {
        this.Modaleditdtl1 = true
        this.dokap_current = id
        this.kd_dokap_current = kd
        this.getDokapdtl()
        this.getDtlDokap(kd)
      } else if (kd === 256) {
        this.Modaleditdtl2 = true
        this.dokap_current = id
        this.getDokapdtl()
      }
    },
    editDokap (id) {
      this.ResetField()
      this.isLoadingEdit = true
      this.Modaledit = true
      var iddokap = {
        id: id
      }
      this.$http.post('geteditDokap', iddokap)
        .then(response => {
          this.edit.idperdokap = response.data.id_permohonan_dokap
          this.edit.idpermohonan = response.data.id_permohonan
          this.edit.jndok = response.data.kd_dokap
          this.edit.isian1 = response.data.isian1
          this.edit.isian2 = response.data.isian2
          this.edit.akhirberlaku = response.data.akhir_berlaku
          this.edit.keterangan = response.data.keterangan
          this.edit.fl_file = response.data.fl_file
          this.getDtlDokap(response.data.kd_dokap)
          this.Reset()
          this.isLoadingEdit = false
        })
    },
    Reset () {
      // Reset our form values
      this.isidokap.jndok = null
      this.isidokap.isian1 = null
      this.isidokap.isian2 = null
      this.isidokap.akhirberlaku = null
      this.isidokap.keterangan = null
      this.isidokap.file = null
      this.field.isi1 = null
      this.field.tipe1 = null
      this.field.isi2 = null
      this.field.tipe2 = null
      this.field.expire = null
      this.field.tabel_ref = null
      this.field.kolom1 = null
      this.field.kolom2 = null
      this.field.fl_file = null
      this.jnPelln = []
      this.nocont = null
      this.ukcont = null
      // this.fileSize = 0
      // this.fileExt = ''
      // this.fileName = ''
      // this.fileValid = ''
    },
    ResetField () {
      // Reset our form values
      this.field.isi1 = null
      this.field.tipe1 = null
      this.field.isi2 = null
      this.field.tipe2 = null
      this.field.expire = null
      this.field.tabel_ref = null
      this.field.kolom1 = null
      this.field.kolom2 = null
      this.field.fl_file = null
      this.isidokap.negara = '-'
      this.isidokap.file = null
      this.edit.negara = '-'
      this.jnPelln = []
      this.cont = null
      this.ukuran = null
      this.dataNoStrip.noPpftz = null
      this.dataNoStrip.tglPpftz = null
      this.dataNoStrip.noBc11 = null
      this.dataNoStrip.tglBc11 = null
      this.dataNoStrip.pos = null
      this.dataNoStrip.noKontainer = null
      this.dataNoStrip.ukKontainer = null
      // this.fileSize = 0
      // this.fileExt = ''
      // this.fileName = ''
      // this.fileValid = ''
    },
    updateDokap () {
      this.isLoadingEdit = true
      this.$Progress.start()
      if (this.cekFile()) {
        if (this.edit.isian1 === null) {
          this.edit.isian1 = this.edit.negara
        }
        var data = {
          id_permohonan_dokap: this.edit.idperdokap,
          id_permohonan: this.edit.idpermohonan,
          kd_dokap: this.edit.jndok,
          isian1: this.edit.isian1,
          isian2: this.edit.isian2,
          akhirberlaku: this.edit.akhirberlaku,
          keterangan: this.edit.keterangan,
          file: this.edit.fl_file === 'Y' ? this.edit.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('updateDokap', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.$Progress.finish()
            this.getDokap()
            this.getHeader()
            this.saveDokapMasterEdit()
            this.ResetField()
            this.Modaledit = false
            this.isLoadingEdit = false
          }).catch((error) => {
            swal(error.data.status, error.data.message, error.data.status)
            this.isLoadingEdit = false
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
        this.isLoadingEdit = false
      }
    },
    saveDokap () {
      if (this.cekFile()) {
        if (this.isidokap.isian1 === null) {
          this.isidokap.isian1 = this.isidokap.negara
        }
        var data = {
          id_permohonan: this.DataHeader.id_permohonan,
          kd_dokap: this.isidokap.jndok,
          isian1: this.isidokap.isian1,
          isian2: this.isidokap.isian2,
          akhirberlaku: this.isidokap.akhirberlaku,
          keterangan: this.isidokap.keterangan,
          file: this.field.fl_file === 'Y' ? this.isidokap.file : null,
          idrekam: this.user.user,
          ext: this.fileExt
        }
        this.$http.post('savedokap', data)
          .then(response => {
            swal(response.data.status, response.data.message, response.data.status)
            this.getDokap()
            this.saveDokapMasterAdd()
            this.ResetField()
            this.ModalDokap = false
            this.onReset()
          })
      } else {
        swal('Gagal simpan data', this.fileValid, 'error')
      }
    },
    saveDokapMasterAdd () {
      if (this.isidokap.isian1 === null) {
        this.isidokap.isian1 = this.isidokap.negara
      }
      var data = {
        kd_dokap: this.isidokap.jndok,
        nomor: this.isidokap.isian1,
        tanggal: this.isidokap.isian2,
        akhirberlaku: this.isidokap.akhirberlaku,
        keterangan: this.isidokap.keterangan,
        file: this.isidokap.file,
        idrekam: this.user.user,
        ext: this.fileExt
      }
      this.$http.post('saveDokapMaster', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
        })
    },
    saveDokapMasterEdit () {
      if (this.edit.isian1 === null) {
        this.edit.isian1 = this.edit.negara
      }
      var data = {
        kd_dokap: this.edit.jndok,
        nomor: this.edit.isian1,
        tanggal: this.edit.isian2,
        akhirberlaku: this.edit.akhirberlaku,
        keterangan: this.edit.keterangan,
        file: this.edit.file,
        idrekam: this.user.user,
        ext: this.fileExt
      }
      this.$http.post('saveDokapMaster', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
        })
    },
    // ambilData (pnmTabel, pkolom1, pkolom2, pparam) {
    //   var data = {
    //     tabel_ref: pnmTabel,
    //     kolom1: pkolom1,
    //     kolom2: pkolom2,
    //     param: pparam
    //   }
    //   this.$http.post('ambilData', data)
    //     .then(response => {
    //       this.isian = response.data.hasil
    //     })
    // },
    confir (iddel) {
      swal({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deleteDokap(iddel)
          }
        })
    },
    confirmdtl (iddel) {
      swal({
        title: 'Hapus dokumen pelengkap',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deleteDokapdtl(iddel)
          }
        })
    },
    deleteDokap (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('deleteDokap', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.getHeader()
          this.ResetField()
        })
    },
    deleteDokapdtl (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('deleteDokapdtl', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.getHeader()
          this.ResetField()
          this.Reset()
        })
    },
    // convert csv to json
    csvJSON (csvText) {
      let lines = []
      const linesArray = csvText.split('\n')
      // for trimming and deleting extra space 
      linesArray.forEach((e) => {
        const row = e.replace(/[\s]+[,]+|[,]+[\s]+/g, ',').trim()
        lines.push(row)
      })
      // for removing empty record
      lines.splice(lines.length - 1, 1)
      const result = []
      const headers = lines[0].split(',')

      for (let i = 1; i < lines.length; i++) {
        const obj = {}
        const currentline = lines[i].split(',')

        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentline[j]
        }
        result.push(obj)
      }
      // return result; //JavaScript object
      // return JSON.stringify(result); //JSON
      return result
    },
    // csvJSON (csv) {
    //   var vm = this
    //   var lines = csv.split('\n')
    //   var result = []
    //   var headers = lines[0].split(',')
    //   vm.parse_header = lines[0].split(',')
    //   lines[0].split(',').forEach(function (key) {
    //     vm.sortOrders[key] = 1
    //   })

    //   lines.map(function (line, indexLine) {
    //     if (indexLine < 1) return // Jump header line

    //     var obj = {}
    //     var currentline = line.split(',')
    //     currentline = line.replace(/\/r/g, '')

    //     headers.map(function (header, indexHeader) {
    //       obj[header] = currentline[indexHeader]
    //     })

    //     result.push(obj)
    //   })

    //   result.pop() // remove the last item because undefined values

    //   return result // JavaScript object
    // },
    loadCSV (e) {
      var vm = this
      if (window.FileReader) {
        var reader = new FileReader()
        reader.readAsText(e.target.files[0])
        // Handle errors load
        reader.onload = function (event) {
          var csv = event.target.result
          vm.parse_csv = vm.csvJSON(csv)
          vm.cont = vm.csvJSON(csv)
        }
        reader.onerror = function (evt) {
          if (evt.target.error.name === 'NotReadableError') {
            swal('Cannot read file !')
          }
        }
      } else {
        swal('FileReader are not supported in this browser.')
      }
    },
    savedokapdtl2 () {
      var data = {
        id_dokap: this.dokap_current,
        idrekam: this.user.user,
        noPpftz: this.dataNoStrip.noPpftz,
        tglPpftz: this.dataNoStrip.tglPpftz,
        noBc11: this.dataNoStrip.noBc11,
        tglBc11: this.dataNoStrip.tglBc11,
        pos: this.dataNoStrip.pos,
        noKontainer: this.dataNoStrip.noKontainer,
        ukKontainer: this.dataNoStrip.ukKontainer
      }
      const fieldsToCheck = {
        noPpftz: 'No PPFTZ',
        tglPpftz: 'Tanggal PPFTZ',
        noBc11: 'No BC11',
        tglBc11: 'Tanggal BC11',
        pos: 'POS',
        noKontainer: 'No Kontainer',
        ukKontainer: 'Ukuran Kontainer'
      }

      for (const [key, label] of Object.entries(fieldsToCheck)) {
        if (!data[key] || data[key].toString().trim() === '') {
          swal('Peringatan', `Kolom ${label} belum diisi`, 'warning')
          return
        }
      }
      this.$http.post('savedokapdtl2', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.ResetField()
          this.Reset()
        })
    },
    confirmdtl2 (id) {
      swal({
        title: 'Hapus Data',
        text: 'Anda yakin akan menghapus data ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.deleteDokapdtl2(id)
          }
        })
    },
    deleteDokapdtl2 (id) {
      var data = {
        user: this.$store.getters['auth/user']['username'],
        delid: id
      }
      this.$http.post('deleteDokapdtl2', data)
        .then(response => {
          swal(response.data.status, response.data.message, response.data.status)
          this.getDokapdtl()
          this.ResetField()
          this.Reset()
        })
    }
  },
  components: {
    VueNumeric,
    HalfCircleSpinner,
    Loading,
    ModelListSelect
  }
}
</script>
<style scoped>
.font {
  font-size: 15;
}
</style>



// WEBPACK FOOTER //
// src/views/Pengajuan/DetilHeader.vue?17fb0be3